import type { KompilDesktopApi } from "@ide/shared";

declare global {
  interface Window {
    /** Ponte do app desktop (apps/desktop/src/preload.ts). Ausente no navegador. */
    kompilDesktop?: KompilDesktopApi;
  }
}

/** App desktop (Electron) ou `null` no navegador. */
export const desktop: KompilDesktopApi | null =
  typeof window === "undefined" ? null : (window.kompilDesktop ?? null);

export const isMac = desktop
  ? desktop.platform === "darwin"
  : typeof navigator !== "undefined" && /Mac|iPhone|iPad/.test(navigator.userAgent);

/** Navega dentro do app a partir de código fora do React (ex.: clique numa notificação). */
export function navigateTo(path: string) {
  window.dispatchEvent(new CustomEvent<string>("kompil:navigate", { detail: path }));
}

/** Posição na pilha de telas do app (o React Router guarda em history.state.idx). */
const historyIndex = () => {
  const idx = (window.history.state as { idx?: unknown } | null)?.idx;
  return typeof idx === "number" ? idx : 0;
};

/**
 * Volta uma tela. Sem tela anterior (o app abriu direto no projeto), vai para Projetos — a seta
 * nunca fica sem destino fora da lista de projetos.
 */
export function backOnePage() {
  if (historyIndex() > 0) window.history.back();
  else if (!/^\/projects\/?$/.test(window.location.pathname)) navigateTo("/projects");
}

/** Avança uma tela (se houver). */
export function forwardOnePage() {
  window.history.forward();
}

/** Abre o caminho atual (ou outro) no app desktop instalado, pelo link kompil://. */
export function desktopLink(path = window.location.pathname): string {
  const clean = path.replace(/^\/+/, "");
  return `kompil://${clean || "projects"}`;
}
